<template>
  <div class="activity-wrap">
    <app-header />
    <div class="banner_top">
      <div class="banner_main">
        <img
          class="logo_img"
          src="../../assets/images/activity/activityforecast2024/logo.png"
          alt=""
        />
        <img
          class="title_text_img"
          src="../../assets/images/activity/activityforecast2024/header_text.png"
          alt=""
        />
        <div class="title_box">
          <img
            src="../../assets/images/activity/activityforecast2024/title_img.png"
            alt=""
          />
          <span class="text_sp"><span>2023</span>-大智慧6大实用功能升级</span>
          <img
            src="../../assets/images/activity/activityforecast2024/title_img.png"
            alt=""
          />
        </div>
        <p class="fu_tit">哪个功能是你心中的年度NO.1</p>
      </div>
    </div>
    <div class="content_main">
      <div class="content_box">
        <div class="first_text_box">
          <span class="yuan_box"><span></span></span>
          <p> 过去一年，大智慧PC软件不断创新升级，从上线<span>“龙头看盘”、全面优化“股票池”功能，到看盘系统的全面升级（证券信息速递+灵活屏功能）以及六剑合一指标的推出</span>等，更多的投资实用功能革新仍在进行中。2023，我们始终在努力，只为做到更好。</p>
          
        </div>
        <div class="first_main">
          <div class="nav_main clearfix">
            <div
              :class="navIndex === index ? 'nav_li active' : 'nav_li'"
              v-for="(item, index) in navList"
              :key="index"
              @click="checkSwiper(index)"
            >
              {{ item.name }} <span class="type_box">{{ item.type }}</span>
            </div>
          </div>
          <div class="first_swiper_main">
            <div class="swiper-container swiper-container-first" ref="swiper1">
              <div class="swiper-wrapper">
                <div
                  v-for="(item, index) in navList"
                  :key="index"
                  class="swiper-slide"
                >
                  <img :src="item.img" alt="" />
                </div>
              </div>
            </div>
            <div class="swiper-button-next swiper-button-black">
              <img :src="rightImg" alt="" />
            </div>
            <div class="swiper-button-prev swiper-button-black">
              <img :src="leftImg" alt="" />
            </div>
            <img
              class="food_img_box"
              src="../../assets/images/activity/activityforecast2024/food_img.png"
              alt=""
            />
          </div>
        </div>
        <div class="title_box">
          <img
            src="../../assets/images/activity/activityforecast2024/title_img.png"
            alt=""
          />
          <span class="text_sp">千档委托监控+超赢思维</span>
          <img
            src="../../assets/images/activity/activityforecast2024/title_img.png"
            alt=""
          />
        </div>
        <p class="fu_tit">大智慧2024新功能强势助力</p>

        <div class="secend_main">
          <img
            class="tit_box_img"
            src="../../assets/images/activity/activityforecast2024/first_tit_img.png"
            alt=""
          />
          <div class="text_main">
            <p>
              实时<span>监控千档买卖盘中任一委托单</span>，并可对该笔委托设置<span>高亮显示、成交/撤单预警提示</span>等操作。
            </p>
            <p>（大智慧「365」收费版及以上版本特有功能）</p>
          </div>
          <div class="first_swiper_main swiper_main_two">
            <div class="swiper-container swiper-container-box" ref="swiper2">
              <div class="swiper-wrapper">
                <div
                  v-for="(item, index) in swiperTwoImg"
                  :key="index"
                  class="swiper-slide"
                >
                  <img :src="item.img" alt="" />
                </div>
              </div>
            </div>
            <div class="swiper-button-next swiper-button-black">
              <img :src="rightImg" alt="" />
            </div>
            <div class="swiper-button-prev swiper-button-black">
              <img :src="leftImg" alt="" />
            </div>
            <img
              class="link_box"
              @click="linkqdwtjk"
              src="../../assets/images/activity/activityforecast2024/first_link_button.png"
            />
          </div>
          <div class="line_first"></div>
          <div class="line_last"></div>
        </div>

        <div class="privilege_main">
          <div class="tit">大智慧「365」特权</div>
          <img
            src="../../assets/images/activity/activityforecast2024/privilege_img.png"
            alt=""
          />
        </div>

        <div class="thinking_main">
          <img
            class="tit_imh_box"
            src="../../assets/images/activity/activityforecast2024/thinking_tit_img.png"
            alt=""
          />
          <div class="text_box">
            超赢思维是以先进的数学模型、计算机技术，辅助投资者预测股价关键支撑位和压力位的量化分析模型，投资者可根据关注的波段高低点进行划线分析，研判股价走势，分为「两点预测」、「三点预测」。
            <span>（大智慧「专业版」及以上版本特有功能）</span>
          </div>
          <div class="first_swiper_main swiper_main_three">
            <div
              class="swiper-container swiper-container-thinking"
              ref="swiper3"
            >
              <div class="swiper-wrapper">
                <div
                  v-for="(item, index) in swiperThreeImg"
                  :key="index"
                  class="swiper-slide"
                >
                  <img :src="item.img" alt="" />
                </div>
              </div>
            </div>
            <div class="swiper-button-next swiper-button-black">
              <img :src="rightImg" alt="" />
            </div>
            <div class="swiper-button-prev swiper-button-black">
              <img :src="leftImg" alt="" />
            </div>
            <img
              class="link_box"
              @click="goToCysw"
              src="../../assets/images/activity/activityforecast2024/thinking_link_img .png"
            />
          </div>
          <div class="line_first"></div>
          <div class="line_last"></div>
        </div>

        <div class="privilege_speciality_main">
          <div class="tit">大智慧「专业版」特权</div>
          <div class="cont_box">
            <ul>
              <li v-for="(item, index) in specialityPrivilegeList" :key="index">
                <p>{{ item.tit }}</p>
                <p>{{ item.text }}</p>
              </li>
            </ul>
          </div>
        </div>

        <div class="context_text_line">
          精益求新 缔造价值，下一站2024，我们会更好！
        </div>

        <div class="title_box">
          <img
            src="../../assets/images/activity/activityforecast2024/title_img.png"
            alt=""
          />
          <span class="text_sp">回顾2023</span>
          <img
            src="../../assets/images/activity/activityforecast2024/title_img.png"
            alt=""
          />
        </div>

        <div class="review_box_main clearfix">
          <div class="left_box">
            <img
              src="../../assets/images/activity/activityforecast2024/review_one.png"
              alt=""
            />
            <img
              @click="goTopTen"
              class="link_bottom"
              src="../../assets/images/activity/activityforecast2024/link_go.png"
              alt=""
            />
          </div>
          <div class="right_box">
            <img
              src="../../assets/images/activity/activityforecast2024/review_two.png"
              alt=""
            />
            <img
              @click="goBigNote"
              class="link_bottom"
              src="../../assets/images/activity/activityforecast2024/link_go.png"
              alt=""
            />
          </div>
        </div>

        <div class="title_box">
          <img
            src="../../assets/images/activity/activityforecast2024/title_img.png"
            alt=""
          />
          <span class="text_sp">展望2024</span>
          <img
            src="../../assets/images/activity/activityforecast2024/title_img.png"
            alt=""
          />
        </div>

        <div class="forecast_main">
          <img
            class="bg_img"
            src="../../assets/images/activity/activityforecast2024/forecast_img.png"
            alt=""
          />
          <img
            @click="goInstitutionStrategy"
            class="link_bottom"
            src="../../assets/images/activity/activityforecast2024/link_go.png"
            alt=""
          />
        </div>
      </div>
    </div>
    <div class="footer">
      <p class="wrap">
        风险提示：本产品不涉及投资咨询及投资顾问服务，所展示信息不构成投资建议；数据基于历史，不代表未来趋势；<br />所有工具都有局限性，适合不同情况下的市场，仅供参考，请理性投资，控制风险，投资有风险，入市需谨慎。
      </p>
    </div>
  </div>
</template>
<script>
import AppHeader from "@/components/common/AppHeader.vue";
export default {
  components: {
    AppHeader,
  },
  data() {
    return {
      token: "",
      navList: [
        {
          name: "灵活屏",
          type: "上线",
          img: require("../../assets/images/activity/activityforecast2024/lhp_img.png"),
        },
        {
          name: "六剑合一",
          type: "上线",
          img: require("../../assets/images/activity/activityforecast2024/lmsj_img.png"),
        },
        {
          name: "证券信息速递",
          type: "新增",
          img: require("../../assets/images/activity/activityforecast2024/zqxx_img.png"),
        },
        {
          name: "股票池",
          type: "优化",
          img: require("../../assets/images/activity/activityforecast2024/gpc_img.png"),
        },
        {
          name: "龙头看盘",
          type: "上线",
          img: require("../../assets/images/activity/activityforecast2024/ltkp_img.png"),
        },
        {
          name: "美股频道",
          type: "优化",
          img: require("../../assets/images/activity/activityforecast2024/mgpd_img.png"),
        },
      ],
      navIndex: 0,
      leftImg: require("../../assets/images/activity/activityforecast2024/left_img.png"),
      rightImg: require("../../assets/images/activity/activityforecast2024/right_img.png"),
      swiperTwoImg: [
        {
          img: require("../../assets/images/activity/activityforecast2024/qdwtjk_one_img.png"),
        },
        {
          img: require("../../assets/images/activity/activityforecast2024/qdwtjk_two_img.png"),
        },
        {
          img: require("../../assets/images/activity/activityforecast2024/qdwtjk_three_img.png"),
        },
      ],
      swiperThreeImg: [
        {
          img: require("../../assets/images/activity/activityforecast2024/thinking_swiper_one.png"),
        },
        {
          img: require("../../assets/images/activity/activityforecast2024/thinking_swiper_two.png"),
        },
      ],
      specialityPrivilegeList: [
        { tit: "「365」全部功能", text: "沪深level-2、千档全推行情等特权" },
        { tit: "自设股票池", text: "个性化编写属于自己的投资策略" },
        { tit: "超赢实时监控", text: "监控超大户、大户、中户、散户资金动向" },
        { tit: "机构去哪儿", text: "机构最新热门调研追踪、排序" },
        { tit: "董秘爆料", text: "第一时间拿到投资者与董秘互动消息" },
        { tit: "热点狙击", text: "盘前、盘中捕捉热点行业中的热点个股" },
      ],
    };
  },
  created() {
    var token = this.$route.query.token;
    if (token) {
      this.token = token;
    }
  },
  mounted() {
    this.getFirstSwiper();
    this.getSentedSwiper();
    this.getThinkingSwiper();
  },
  methods: {
    getFirstSwiper: function () {
      var that = this;
      var swiper = new this.$swiper(".swiper-container-first", {
        loop: true, // 无缝
        autoplay: {
          //自动开始
          delay: 5000, //时间间隔
          disableOnInteraction: false, //*手动操作轮播图后不会暂停*
        },
        on: {
          slideChangeTransitionEnd: function () {
            if (that.$refs.swiper1.swiper.activeIndex == 7) {
              that.navIndex = 0;
            } else {
              that.navIndex = that.$refs.swiper1.swiper.activeIndex - 1;
            }
          },
        },
        navigation: {
          nextEl: ".swiper-button-next",
          prevEl: ".swiper-button-prev",
        },
      });
      swiper.el.onmouseover=function(){
        swiper.autoplay.stop();
      }
      swiper.el.onmouseleave=function(){
        swiper.autoplay.start();
      }
    },

    checkSwiper: function (index) {
      var that = this;
      that.$refs.swiper1.swiper.slideTo(index + 1);
      that.navIndex = index;
    },

    getSentedSwiper: function () {
      var that = this;
      var swiperContainer = new this.$swiper(".swiper-container-box", {
        loop: true, // 无缝
        autoplay: {
          //自动开始
          delay: 5000, //时间间隔
          disableOnInteraction: false, //*手动操作轮播图后不会暂停*
        },
        navigation: {
          nextEl: ".swiper-button-next",
          prevEl: ".swiper-button-prev",
        },
      });
      swiperContainer.el.onmouseover=function(){
        swiperContainer.autoplay.stop();
      }
      swiperContainer.el.onmouseleave=function(){
        swiperContainer.autoplay.start();
      }
    },

    getThinkingSwiper: function () {
      var that = this;
      var swiperthinking = new this.$swiper(".swiper-container-thinking", {
        loop: true, // 无缝
        autoplay: {
          //自动开始
          delay: 5000, //时间间隔
          disableOnInteraction: false, //*手动操作轮播图后不会暂停*
        },
        navigation: {
          nextEl: ".swiper-button-next",
          prevEl: ".swiper-button-prev",
        },
      });
      swiperthinking.el.onmouseover=function(){
        swiperthinking.autoplay.stop();
      }
      swiperthinking.el.onmouseleave=function(){
        swiperthinking.autoplay.start();
      }
    },

    goTopTen:function(){
      window.open("/pay-mall/activity/activityTopTen2023")
    },

    goBigNote:function(){
      window.open("/pay-mall/activity/activityBigNote2023")
    },

    goInstitutionStrategy:function(){
      window.open("/pay-mall/activity/activityInstitutionStrategy2024")
    },
    linkqdwtjk:function(){
      window.open("https://pay.dzh.com.cn/pay-mall/order/confirm/116/12")
    },
    goToCysw:function(){
      window.open("https://pay.dzh.com.cn/pay-mall/order/confirm/73/12")
    }
  },
};
</script>
<style lang="scss" scoped>
// 清除浮动
.clearfix:before,
.clearfix:after {
  content: "";
  display: table;
}
.clearfix:after {
  clear: both;
}
.activity-wrap {
  background: #a90000;
  background-image: -webkit-linear-gradient(
    top,
    #ab0001 0%,
    #a90000 50%,
    #a90000 100%
  );
  overflow: hidden;
  overflow: hidden;
  .banner_top {
    width: 100%;
    background: url("../../assets/images/activity/activityforecast2024/header.png")
      no-repeat center top;
    background-size: 100% 532px;
    position: relative;
    height: 580px;
    text-align: center;
    overflow: hidden;
    box-sizing: border-box;

    .banner_main {
      width: 1080px;
      height: 100%;
      margin: 0 auto;
      padding-top: 450px;
      position: relative;
      .logo_img {
        width: 215px;
        height: 70px;
        position: absolute;
        top: 0;
        left: 0;
      }
      .title_text_img {
        width: 790px;
        height: 221px;
        position: absolute;
        top: 121px;
        left: 150px;
      }
      .title_box {
        display: flex;
        align-items: center;
        justify-content: center;
        img {
          width: 108px;
          height: 42px;
        }
        .text_sp {
          margin-left: 18px;
          margin-right: 18px;
          font-size: 36px;
          color: #fff;
          span {
            background-image: -webkit-linear-gradient(
              top,
              #ffffff,
              #fffacf,
              #fff498
            );
            -webkit-background-clip: text;
            -webkit-text-fill-color: transparent;
          }
        }
      }
      .fu_tit {
        text-align: center;
        font-size: 24px;
        margin-top: 20px;
        color: #fff;
      }
    }
  }
  .content_main {
    width: 100%;
    background-color: #a60107;
    .content_box {
      width: 1080px;
      height: 100%;
      margin: 0 auto;
      padding-bottom: 98px;
      .first_text_box {
        font-size: 22px;
        color: #fff;
        line-height: 36px;
        padding-left: 50px;
        position: relative;
        border-bottom: 3px solid #ce041a;
        .yuan_box {
          width: 20px;
          height: 20px;
          display: inline-block;
          border-radius: 50%;
          background-color: rgba(255, 255, 255, 0.45);
          position: absolute;
          top: 5px;
          left: 11px;
          span {
            display: inline-block;
            width: 12px;
            height: 12px;
            border-radius: 50%;
            background-color: #fff;
            position: absolute;
            top: 4px;
            left: 4px;
          }
        }
        p{
          color: rgba(255,255,255,0.9);
          span{
            color: rgba(255,255,255,1);
            font-weight: 600;
          }
        }
      }
      .first_main {
        padding-top: 32px;
        .nav_main {
          width: 100%;
          padding: 0 22px;
          box-sizing: border-box;
          .nav_li {
            float: left;
            width: 150px;
            height: 45px;
            background-image: linear-gradient(
              -90deg,
              rgba(187, 131, 70, 1) 0%,
              rgba(215, 187, 157, 1) 100%
            );
            border-radius: 20px 20px 0px 0px;
            box-sizing: border-box;
            margin-right: 25px;
            font-size: 23px;
            text-align: center;
            line-height: 45px;
            color: rgba(0, 0, 0, 1);
            position: relative;
            cursor: pointer;
            &:last-child {
              margin-right: 0;
            }
            .type_box {
              position: absolute;
              display: inline-block;
              width: 47px;
              height: 26px;

              background-image: linear-gradient(
                90deg,
                rgba(188, 76, 111, 1) 0%,
                rgba(199, 107, 134, 1) 100%
              );
              box-shadow: 0px 0px 5px 0px rgba(232, 164, 181, 1);
              border-radius: 13px;
              font-size: 15px;
              color: #fff;
              line-height: 26px;
              top: -10px;
              right: -10px;
            }
            &.active {
              background-image: linear-gradient(
                -90deg,
                rgba(255, 212, 11, 1) 0%,
                rgba(255, 234, 136, 1) 100%
              );
              .type_box {
                background-image: linear-gradient(
                  90deg,
                  rgba(254, 23, 28, 1) 0%,
                  rgba(255, 68, 68, 1) 100%
                );
                box-shadow: 0px 0px 5px 0px rgba(255, 66, 69, 1);
              }
            }
          }
        }
        .first_swiper_main {
          width: 100%;
          height: 1034px;
          margin: 0 auto;
          background-color: rgba(110, 26, 13, 1);
          border-radius: 8px;
          padding: 16px 30px 0px;
          box-sizing: border-box;
          position: relative;
          .swiper-container {
            width: 100%;
            .swiper-wrapper {
              width: 100%;
              height: 910px;
              .swiper-slide {
                width: 1008px;
                height: 100%;
              }
            }
          }

          .food_img_box {
            position: absolute;
            bottom: 0;
            width: 1097px;
            height: 88px;
            left: -8px;
          }
        }
      }
      .title_box {
        display: flex;
        align-items: center;
        justify-content: center;
        margin-top: 75px;
        img {
          width: 108px;
          height: 42px;
        }
        .text_sp {
          margin-left: 46px;
          margin-right: 46px;
          font-size: 36px;
          color: #fff;

          span {
            background-image: -webkit-linear-gradient(
              top,
              #ffffff,
              #fffacf,
              #fff498
            );
            -webkit-background-clip: text;
            -webkit-text-fill-color: transparent;
          }
        }
      }
      .fu_tit {
        text-align: center;
        font-size: 24px;
        margin-top: 20px;
        color: #fff;
        margin-bottom: 42px;
      }
      .secend_main {
        width: 100%;
        background-color: #6e1a0d;
        border-radius: 8px;
        height: 750px;
        position: relative;
        padding: 120px 19px 0 19px;
        box-sizing: border-box;
        margin-bottom: 47px;
        .tit_box_img {
          width: 244px;
          height: 60px;
          position: absolute;
          top: 24px;
          left: -10px;
        }
        .text_main {
          p {
            &:first-child {
              font-size: 24px;
              color: rgba(255, 255, 255, 1);
              text-indent: 16px;
              span {
                color: rgba(255, 231, 121, 1);
              }
            }
            &:last-child {
              font-size: 24px;
              color: rgba(255, 255, 255, 0.5);
              margin-bottom: 35px;
            }
          }
        }
        .swiper_main_two {
          text-align: center;
          .link_box {
            width: 508px;
            height: 74px;
            margin: 0 auto;
            margin-top: 38px;
            cursor: pointer;
          }
        }
        .line_first {
          width: 10px;
          height: 48px;
          background-color: rgba(110, 26, 13, 1);
          position: absolute;
          bottom: -48px;
          left: 145px;
        }
        .line_last {
          width: 10px;
          height: 48px;
          background-color: rgba(110, 26, 13, 1);
          position: absolute;
          bottom: -48px;
          right: 145px;
        }
      }
      .privilege_main {
        width: 100%;
        height: 405px;
        background-color: rgba(110, 26, 13, 1);
        border-radius: 8px;
        padding: 36px 80px 50px;
        box-sizing: border-box;
        margin-bottom: 45px;
        .tit {
          font-size: 30px;
          color: #fff;
          text-align: center;
          margin-bottom: 35px;
        }
        img {
          width: 100%;
          height: 244px;
        }
      }
      .thinking_main {
        width: 100%;
        height: 775px;
        background-color: rgba(110, 26, 13, 1);
        border-radius: 8px;
        margin-bottom: 43px;
        position: relative;
        padding: 102px 19px 0 19px;
        box-sizing: border-box;
        .tit_imh_box {
          width: 180px;
          height: 60px;
          position: absolute;
          top: 24px;
          left: -10px;
        }
        .text_box {
          font-size: 24px;
          line-height: 36px;
          color: #fff;
          margin-bottom: 20px;
          span {
            color: rgba(255, 255, 255, 0.5);
          }
        }
        .swiper_main_three {
          margin-bottom: 12px;
          text-align: center;
          .link_box {
            width: 508px;
            height: 74px;
            margin: 0 auto;
            margin-top: 12px;
            cursor: pointer;
          }
        }
        .line_first {
          width: 10px;
          height: 48px;
          background-color: rgba(110, 26, 13, 1);
          position: absolute;
          bottom: -48px;
          left: 145px;
        }
        .line_last {
          width: 10px;
          height: 48px;
          background-color: rgba(110, 26, 13, 1);
          position: absolute;
          bottom: -48px;
          right: 145px;
        }
      }
      .privilege_speciality_main {
        width: 100%;
        height: 444px;
        background-color: rgba(110, 26, 13, 1);
        border-radius: 8px;
        padding: 36px 26px 0 26px;
        box-sizing: border-box;
        margin-bottom: 42px;
        .tit {
          font-size: 30px;
          color: #fff;
          text-align: center;
          margin-bottom: 35px;
        }
        .cont_box {
          width: 100%;
          ul {
            width: 100%;
            li {
              display: inline-block;
              width: 490px;
              height: 84px;
              padding: 12px 0 0 26px;
              box-sizing: border-box;
              border: solid 1px rgba(185, 28, 34, 1);
              margin-bottom: 26px;
              &:nth-child(even) {
                margin-left: 32px;
              }
              &:nth-child(5),
              &:nth-child(6) {
                margin-bottom: 0px;
              }
              p {
                &:first-child {
                  font-size: 19px;
                  color: #fff;
                }
                &:last-child {
                  font-size: 25px;
                  color: rgba(255, 222, 0, 1);
                }
              }
            }
          }
        }
      }
      .context_text_line {
        font-size: 31px;
        text-align: center;
        background-image: -webkit-linear-gradient(top, #fff, #fffacf, #fff498);
        -webkit-background-clip: text;
        -webkit-text-fill-color: transparent;
        margin-bottom: 80px;
      }
      .review_box_main {
        width: 100%;
        margin-top: 40px;
        padding: 46px 53px 37px 47px;
        box-sizing: border-box;
        background-color: rgba(110, 26, 13, 1);
        border-radius: 8px;
        margin-bottom: 74px;
        .left_box {
          width: 456px;
          height: 258px;
          float: left;
          position: relative;
          img {
            width: 100%;
            height: 100%;
          }
          .link_bottom {
            width: 244px;
            height: 70px;
            position: absolute;
            top: 160px;
            left: 106px;
            cursor: pointer;
          }
        }
        .right_box {
          width: 456px;
          height: 258px;
          float: right;
          position: relative;
          img {
            width: 100%;
            height: 100%;
          }
          .link_bottom {
            width: 244px;
            height: 70px;
            position: absolute;
            top: 160px;
            left: 106px;
            cursor: pointer;
          }
        }
      }
      .forecast_main {
        margin-top: 40px;
        width: 100%;
        padding: 46px 52px 49px 47px;
        box-sizing: border-box;
        background-color: rgba(110, 26, 13, 1);
        border-radius: 8px;
        position: relative;
        .bg_img {
          width: 100%;
          height: 180px;
        }
        .link_bottom {
          width: 244px;
          height: 70px;
          position: absolute;
          top: 96px;
          right: 106px;
          cursor: pointer;
        }
      }
    }
  }
  .footer {
    background: #3f3f3f;
    text-align: center;
    padding: 20px 0 30px;
  }
  .footer p {
    font-size: 14px;
    color: #fff;
    opacity: 0.3;
    line-height: 2;
  }
  .swiper-button-next {
    img {
      width: 60px;
      height: 60px;
    }
  }
  .swiper-button-prev {
    left: -22px;
    img {
      width: 60px;
      height: 60px;
    }
  }
}
</style>

<style>
.swiper-button-prev {
  background-image: none !important;
}
.swiper-button-next {
  background-image: none !important;
}
</style>


// WEBPACK FOOTER //
// src/pages/activity/activityforecast2024.vue